import { giphyDarkCharcoal, giphyLightestGrey } from '@giphy/react-giphy-brand/src/css/colors'
import { ReactNode, useState } from 'react'
import styled from 'styled-components'
import { IconButton, TextInput } from 'ui'
import CreationToolUploadField from '../../../types/upload-field'
import CreationTag from '../../tag'
import { CreationToolUploadTag } from '../../upload/types'
import CollapsibleField from './field-collapsible'
import TaggingHelp from '../../upload/copilot/tag-manager/tagging-help'

const Tags = styled.div`
    margin-top: 15px;
`

const Tag = styled(CreationTag)`
    margin: 0 8px 10px 0;
`

const Bin = styled.div`
    position: relative;
`

type Props = {
    children?: ReactNode
    className?: string
    tags?: CreationToolUploadTag[]
    isBulk?: boolean
    showInstructions?: boolean
    field: CreationToolUploadField
    onRemove: (tag: string) => void
    onAdd: (tags: string[]) => void
    onToggleFeatured: (tag: string) => void
    enableFeatured: boolean
}

const CreationTagsField = ({
    children,
    className,
    tags = [],
    showInstructions = false,
    field,
    onRemove,
    onAdd,
    onToggleFeatured,
    enableFeatured,
}: Props) => {
    const description = CreationToolUploadField.description(field)
    const [value, setValue] = useState<string>('')

    const setTags = () => {
        if (!value) return

        // split tags by comma and add them to the list
        const tags = value.split(',').filter((tag) => tag !== '')
        setValue('')
        if (tags.length) {
            return onAdd(tags)
        }
    }

    return (
        <CollapsibleField className={className} field={field}>
            <Bin>
                {showInstructions && <TaggingHelp>{CreationToolUploadField.instructions(field)}</TaggingHelp>}
                <TextInput
                    placeholder={description}
                    size="medium"
                    value={value}
                    onChange={setValue}
                    onEnterKeyPress={() => setTags()}
                >
                    <IconButton
                        color={giphyDarkCharcoal}
                        icon="add"
                        iconColor={giphyLightestGrey}
                        size="medium"
                        onClick={() => setTags()}
                    />
                </TextInput>
            </Bin>

            {tags.length > 0 && (
                <Tags>
                    {tags.map((tag) => (
                        <Tag
                            key={tag.text}
                            tag={tag.text}
                            onRemove={onRemove}
                            isFeatured={!!tag.isFeatured}
                            onToggleFeatured={onToggleFeatured}
                            enableFeatured={enableFeatured}
                        />
                    ))}
                </Tags>
            )}
            {children}
        </CollapsibleField>
    )
}

export default CreationTagsField
